import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, filter, switchMap } from 'rxjs/operators';


export class AppConfig
{
//Your properties here
  readonly production: boolean;
  readonly ArClientName:  string ;
  readonly EnClientName: string ;
  readonly ArProductName: string ;
  readonly EnProductName: string ;
  readonly webapiurl: string ;
  readonly Repwebapiurl:string;
  readonly TenantId: string;
  readonly Version: string;

  readonly  mapboxapi : 'pk.eyJ1IjoiZXNsYW1tb2hhbWVkNDEiLCJhIjoiY2t0OXJ0ZGR5MWY2eTJwanB4MXM2aW5yNSJ9.d5ptPfxXSbC2fynF04D2ZQ';
}
export let APP_CONFIG: AppConfig = new AppConfig();


@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private appConfig: any;
  constructor(private http: HttpClient) { }

  loadAppConfig() {
    return this.http.get('/assets/appConfig.json')
      .toPromise()
      .then(data => {
        this.appConfig = data;
        APP_CONFIG = data as AppConfig;
      });
  }

  // This is an example property ... you can make it however you want.
  get webapiurl() {

    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.webapiurl;
  }
}
